var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rootCategory)?_c('div',{staticClass:"categories ui styled fluid accordion"},_vm._l((_vm.children),function(child){return _c('category-node',{key:child.id,attrs:{"userstatus":_vm.getuserStatus,"rootCategory":_vm.rootCategory,"category":child,"level":1,"searchUrlParams":_vm.searchUrlParams}})}),1):_vm._e()}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7c8ed58","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/CategoryTree.vue
// module id = IaDl
// module chunks = 0